import React from 'react';
import { Link } from 'react-router-dom';

// ─── Footer Columns ───────────────────────────────────────────────────────────
const FOOTER_COLS = [
  {
    heading: 'Platform',
    links: [
      { label: 'Magazine',         to: '/magazine' },
      { label: 'Career Hub',       to: '/career-hub' },
      { label: 'First Briefcase',  to: '/first-briefcase' },
      { label: 'Newsletter',       to: '/newsletter' },
      { label: 'First Round',      to: '/first-round' },
    ],
  },
  {
    heading: 'Coverage',
    links: [
      { label: 'Education',          to: '/coverage/education' },
      { label: 'Business & Finance', to: '/coverage/business-finance' },
      { label: 'Healthcare',         to: '/coverage/healthcare' },
      { label: 'Government',         to: '/coverage/government' },
      { label: 'Technology & AI',    to: '/coverage/technology-ai' },
    ],
  },
  {
    heading: 'Advertise',
    links: [
      { label: 'Media Kit',          to: '/media-kit' },
      { label: 'Featured Campus',    to: '/advertise' },
      { label: 'Featured Employer',  to: '/advertise' },
      { label: 'Exemplary Leaders',      modal: 'el' },
      { label: 'Organization Spotlight', modal: 'oif' },
      { label: 'Sponsor an Issue',   to: '/advertise' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us',         to: '/about' },
      { label: 'Newsroom',         to: '/newsroom' },
      { label: 'Contact',          to: '/contact' },
      { label: 'Staff Login 🔒',   to: '/admin/login' },
    ],
  },
];

// ─── Main Footer ──────────────────────────────────────────────────────────────
export const Footer = () => {
  function openElModal() {
    window.dispatchEvent(new CustomEvent('open-el-modal'));
  }
  function openOifModal() {
    window.dispatchEvent(new CustomEvent('open-oif-modal'));
  }

  return (
  <footer className="op-footer" data-testid="site-footer">
    <div className="container-custom op-footer-inner">

      {/* Main grid: brand + 4 columns */}
      <div className="op-footer-main">

        {/* Brand block */}
        <div className="op-footer-brand" data-testid="footer-brand-block">
          <Link to="/" className="op-footer-wordmark" data-testid="footer-brand">
            <span className="op-footer-mark" aria-hidden="true">OP</span>
            <span>Opportunity Post</span>
          </Link>
          <p className="op-footer-tagline">Real opportunity, curated daily.</p>
          <p className="op-footer-desc">
            The leading platform for careers, education, healthcare, business, and
            opportunity in America. Home of the Magazine, Newsletter, Career Hub, and
            First Round daily briefing.
          </p>
        </div>

        {/* Nav columns */}
        {FOOTER_COLS.map(col => (
          <div key={col.heading} className="op-footer-col">
            <h5 className="op-footer-col-heading">{col.heading}</h5>
            <ul>
              {col.links.map(({ label, to, modal }) => (
                <li key={label}>
                  {modal ? (
                    <button
                      data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                      onClick={modal === 'oif' ? openOifModal : openElModal}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit', color: 'inherit', textAlign: 'left' }}
                    >
                      {label}
                    </button>
                  ) : (
                    <Link
                      to={to}
                      data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                    >
                      {label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom strip */}
      <div className="op-footer-bottom" data-testid="footer-bottom">
        <span className="op-footer-copy">
          © 2026 Opportunity Post
        </span>
        <span className="op-footer-bottom-links">
          <Link to="/privacy" data-testid="footer-link-privacy-policy">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-link-terms-of-service">Terms of Service</Link>
          <Link to="/accessibility" data-testid="footer-link-accessibility">Accessibility</Link>
        </span>
      </div>

    </div>
  </footer>
  );
};
